import { Injectable, Inject } from '@angular/core';
import { API_STORAGE } from '../model/pacificwise-angular-config.model';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor(@Inject(API_STORAGE) private storage: any) { }

  getItem(key: string): string {
    return this.storage.getItem(key);
  }

  setItem(key: string, value: string) {
    this.storage.setItem(key, value);
  }

  removeItem(key: string) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }

}
